import React from 'react';
import { rowBgIsRepeat, rowBgMode } from '../utils/rowBackgroundImage';

/**
 * Camada de imagem de fundo da row (builder). Pai deve ter position:relative e só backgroundColor.
 */
export default function RowBackgroundImageLayer({ rc }) {
    const raw = (rc?.bgImage || '').trim();
    if (!raw) return null;
    const op = (rc.bgImageOpacity != null ? rc.bgImageOpacity : 100) / 100;
    const mode = rowBgMode(rc);
    const posX = rc.bgImagePositionX != null ? rc.bgImagePositionX : 50;
    const posY = rc.bgImagePositionY != null ? rc.bgImagePositionY : 50;

    if (rowBgIsRepeat(rc)) {
        const tile = rc.bgImageSize != null ? rc.bgImageSize : 100;
        return (
            <div
                className="madri-row-bg-image"
                style={{
                    position: 'absolute',
                    inset: 0,
                    zIndex: 0,
                    overflow: 'hidden',
                    pointerEvents: 'none',
                    opacity: op,
                    backgroundImage: `url("${raw.replace(/"/g, '%22')}")`,
                    backgroundRepeat: mode,
                    backgroundSize: `${tile}% ${tile}%`,
                    backgroundPosition: `${posX}% ${posY}%`,
                }}
            />
        );
    }

    const rot = rc.bgImageRotate != null ? rc.bgImageRotate : 0;
    const pct = rc.bgImageSize != null ? rc.bgImageSize : 100;
    const ox = `${posX}%`;
    const oy = `${posY}%`;
    const objFit = mode === 'contain' ? 'contain' : mode === 'stretch' ? 'fill' : 'cover';

    return (
        <div
            className="madri-row-bg-image"
            style={{
                position: 'absolute',
                inset: 0,
                zIndex: 0,
                overflow: 'hidden',
                pointerEvents: 'none',
                opacity: op,
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    width: `${pct}%`,
                    height: `${pct}%`,
                    transform: `translate(-50%, -50%) rotate(${rot}deg)`,
                    transformOrigin: 'center center',
                }}
            >
                <img
                    src={raw}
                    alt=""
                    draggable={false}
                    style={{ width: '100%', height: '100%', objectFit: objFit, objectPosition: `${ox} ${oy}` }}
                />
            </div>
        </div>
    );
}
